const { replace } = require('lodash');

class DynamicSuburbDialogContentController {
    constructor(fulfilmentService, settings, shopperService, moveFocus, analytics) {
        this.fulfilmentService = fulfilmentService;
        this.analytics = analytics;

        this.description = replace(settings.deliveryWindows.dynamicSuburbMessageDescription, '{Name}', (shopperService.IsGuest ? '' : shopperService.shopper.FirstName));
    }

    $onInit() {
        this.dialogCtrl.show();
    }

    onTimeSelect() {
        this.fireEventAndCloseDialog('dynamic suburbs popup acknowledged - window selected');
    }

    onDecideLater() {
        this.fireEventAndCloseDialog('dynamic suburbs popup ignored - no window selected');
    }

    fireEventAndCloseDialog(eventFired) {
        this.analytics.pushEvent(eventFired);
        this.closeDialog();
    }

    closeDialog() {
        this.dialogCtrl.close();
    }
}

module.exports = {
    template: require('./dynamicsuburb-dialog-content.component.html').trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ['FulfilmentService', 'Settings', 'ShopperService', 'MoveFocus', 'AnalyticsService', DynamicSuburbDialogContentController],
};



// WEBPACK FOOTER //
// ./src/shop/dynamicsuburb/dynamicsuburb-dialog-content.component.js